import type { AssetsLink } from '#/domain/assetsLink/AssetsLink'
import type { AssetsLinkRepository } from '#/domain/assetsLink/AssetsLinkRepository'

export class GetAssetsLinkUseCase {
  constructor(private readonly repository: AssetsLinkRepository) {}

  async execute(id: string): Promise<AssetsLink> {
    return this.repository.findById(id)
  }
}
